module.exports = __webpack_public_path__ + "images/buttons/import_leads-gray.gif";